import nameOf from 'src/app/shared/form/nameOf.helper';
import { Lab } from 'src/app/models/lab.model';
import { LabRequisition } from 'src/app/models/labRequisition.model';

export const COC_LABELS = {
  chainOfCustody: 'Chain Of Custody',
  turnAroundTime: 'Turn Around Time',
  surcharge: 'Surcharge',
  labRequisitionNumber: 'Lab Requisition Number',
  reportTo: 'Report To',
  companyName: 'Company Name',
  address: 'Address',
  cityStateZip: 'City, State, Zip',
  phoneNumber: 'Phone Number',
  cellNumber: 'Cell Number',
  emailReportTo: 'Email (Report To)',
  emailEdd: 'Email EDD',
  reportToComments: 'Report To Comments',
  invoiceTo: 'Invoice To',
  emailInvoiceTo: 'Email (Invoice To)',
  po: 'PO',
  paymentMethod: 'Payment Method',
  invoiceToComments: 'Invoice To Comments',
  siteName: 'Site Name',
  survey: 'Survey',
  sampledBy: 'Sampled By',
  jurisdiction: 'Jurisdiction',
  generalComments: 'General Comments',
  industryDescription: 'List Description Of Industry Or Process/Interferences Present In Sampling Area',
  sampleNumber: 'Sample Number',
  agentName: 'Agent Name',
  agentGroup: 'Agent Group',
  samplingDate: 'Sampling Date',
  sampleVolume: 'Sample Volume (L)',
  totalTime: 'Total Time (Minutes)',
  flowRate: 'Flowrate',
  methodReference: 'Method Reference',
  printNameSignature: 'Print Name / Signature',
  date: 'Date',
  time: 'Time',
  relinquishedBy: 'Relinquished By',
  receivedBy: 'Received By',
  alsQuoteNumber: 'ALS Quote Number',
  accountInformation: 'Account Information',
  signedByLeap: 'Signed by LEAP',
  alternateSampleNumber: 'Alternate Sample Number'
} as const;

export const COC_MISSING_NUMERIC_PLACEHOLDER = '-';

export const COC_REQUISITION_FIELDS: (keyof LabRequisition)[] = [
  nameOf<LabRequisition>(x => x.labRequisitionNumber),
  nameOf<LabRequisition>(x => x.labAccountNumber),
  nameOf<LabRequisition>(x => x.reportTo),
  nameOf<LabRequisition>(x => x.reportToCompanyName),
  nameOf<LabRequisition>(x => x.reportToAddress1),
  nameOf<LabRequisition>(x => x.reportToPhoneNumber),
  nameOf<LabRequisition>(x => x.reportToCellNumber),
  nameOf<LabRequisition>(x => x.reportToEmail),
  nameOf<LabRequisition>(x => x.emailEdd),
  nameOf<LabRequisition>(x => x.reportToComments),
  nameOf<LabRequisition>(x => x.invoiceTo),
  nameOf<LabRequisition>(x => x.invoiceCompanyName),
  nameOf<LabRequisition>(x => x.invoiceAddress1),
  nameOf<LabRequisition>(x => x.invoicePhoneNumber),
  nameOf<LabRequisition>(x => x.invoiceEmail),
  nameOf<LabRequisition>(x => x.invoicePoNumber),
  nameOf<LabRequisition>(x => x.invoicePaymentInfo),
  nameOf<LabRequisition>(x => x.invoiceComments),
  nameOf<LabRequisition>(x => x.generalComments),
  nameOf<LabRequisition>(x => x.industryProcessInterferenceDescription)
];

export const COC_LAB_FIELDS: (keyof Lab)[] = [
  nameOf<Lab>(x => x.labName),
  nameOf<Lab>(x => x.labAccountNumber),
  nameOf<Lab>(x => x.labAddress1),
  nameOf<Lab>(x => x.labAddress2),
  nameOf<Lab>(x => x.labCity),
  nameOf<Lab>(x => x.labState),
  nameOf<Lab>(x => x.labZip),
  nameOf<Lab>(x => x.labPhoneNumber),
  nameOf<Lab>(x => x.labCellNumber),
  nameOf<Lab>(x => x.labEmail)
];
